export const ADD_ITEMS = "addItems";
export const ERROR = "error";
export const RESET = "reset";
export const RESET_SUGGESTIONS = "resetSuggestions";
export const SET_AVAILABLE_AREAS = "setAvailableAreas";
export const SET_DATA = "setData";
export const SET_SUGGESTIONS = "setSuggestions";
export const SUCCESS = "success";
export const TOGGLE_ITEM = "toggleItem";
